import { NotFoundError } from "./not-found-error";

// Thrown when a scanned code names no transfer carrier of the caller's organisation. The lookup
// accepts a uuid from a printed QR and the plain number painted on the device, so reaching here
// means the code is neither — a shelf label, a vendor barcode, another yard's trolley, or a
// mis-read.
//
// Another organisation's carrier and a code that never existed are deliberately indistinguishable:
// the `transferCarriers` policy scopes the lookup, so both simply select nothing. Telling them
// apart would answer a question the caller has no business asking. 404 for the reason a
// shipping-label scan is.
export class UnknownTransferCarrierError extends NotFoundError {
	constructor() {
		super("stock.unknown_transfer_carrier");
		this.name = "UnknownTransferCarrierError";
	}
}
